// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__kq21I","banner":"Banner_banner__0yjPL"};